import { UnidadeForcaMuscularSelectModel } from 'view/atendimentos/components/MedicoesPanel/UnidadeForcaMuscularSelectField'
import { HistoricoMedicaoModel } from 'view/atendimentos/types/model-historicoMedicao'

import { HistoricoMedicoesModel } from '../model/model-historico'

export const convertMedicaoModelToMedicoesModel = (
  medicoes: ReadonlyArray<HistoricoMedicaoModel>
): HistoricoMedicoesModel[] => {
  return medicoes.map((medicao) => ({
    sinaisVitais: {
      id: medicao.id,
      valorPressaoArterial: medicao.valorPressaoArterial,
      frequenciaRespiratoria: medicao.valorFrequenciaRespiratoria?.toString(),
      frequenciaCardiaca: medicao.valorFrequenciaCardiaca?.toString(),
      temperatura: medicao.valorTemperatura?.toString(),
      saturacaoO2: medicao.valorSaturacaoO2?.toString(),
      glicemia: medicao.valorGlicemia?.toString(),
      tipoGlicemia: medicao.tipoGlicemia,
      dataMedicao: medicao.dataMedicao,
    },
    antropometria: {
      id: medicao.id,
      peso: medicao.valorPeso?.toString(),
      altura: medicao.valorAltura?.toString(),
      imc: medicao.valorImc,
      perimetroCefalico: medicao.valorPerimetroCefalico?.toString(),
      circunferenciaAbdominal: medicao.valorCircunferenciaAbdominal?.toString(),
      perimetroPanturrilha: medicao.perimetroPanturrilha?.toString(),
      valorForcaMuscMaoDireita: medicao.valorForcaMuscMaoDireita,
      unidadeForcaMuscMaoDireita:
        medicao.unidadeForcaMuscMaoDireita &&
        ({
          enum: medicao.unidadeForcaMuscMaoDireita,
        } as UnidadeForcaMuscularSelectModel),
      valorForcaMuscMaoEsquerda: medicao.valorForcaMuscMaoEsquerda,
      unidadeForcaMuscMaoEsquerda:
        medicao.unidadeForcaMuscMaoEsquerda &&
        ({
          enum: medicao.unidadeForcaMuscMaoEsquerda,
        } as UnidadeForcaMuscularSelectModel),
      pele: medicao.pele,
      olhoDireito: medicao.olhoDireito,
      olhoEsquerdo: medicao.olhoEsquerdo,
      ouvidoDireito: medicao.ouvidoDireito,
      ouvidoEsquerdo: medicao.ouvidoEsquerdo,
      membroInferiorDireito: medicao.membroInferiorDireito,
      membroInferiorEsquerdo: medicao.membroInferiorEsquerdo,
      dataMedicao: medicao.dataMedicao,
    },
  }))
}
